import type {IMyTopProductType} from '../Profile/types';

export const MY_TOP_PATH = '/profile/my-top';

export const MY_TOP_TAB_PARAM = 'tab';

export const myTopPathWithTab = (productType: IMyTopProductType): string =>
    `${MY_TOP_PATH}?${MY_TOP_TAB_PARAM}=${productType}`;

